module.exports = __webpack_public_path__ + "img/check_4.4a395417.png";